import {Action, Selector, State, StateContext} from '@ngxs/store';
import {SetFiltros} from '@app/state/restaurant/cocina/cocina-restaurante.actions';
import {Injectable} from '@angular/core';

/** Preferencias del monitor de cocina que se conservan entre sesiones del mismo navegador. */
export interface CocinaFiltros {
    /** Vista activa: PENDIENTE (incluye en preparación), PREPARADO (listos por servir) o DESPACHADO (servidos). */
    estado: 'PENDIENTE' | 'PREPARADO' | 'DESPACHADO';
    /** 'all' | true (para llevar) | false (para aquí). */
    paraLlevar: any;
    /** Minutos a partir de los cuales una comanda se marca en ámbar; el doble la marca en rojo. */
    tiempoPreparacion: number;
    areasProduccionSelect: number[];
    /** Silenciar el aviso sonoro de comanda nueva. */
    silencio: boolean;
    /** Mostrar los ítems anulados dentro de cada comanda. */
    mostrarAnulados: boolean;
}

export class CocinaRestaurantStateModel {
    filtros: CocinaFiltros;
}

export const COCINA_FILTROS_DEFAULT: CocinaFiltros = {
    estado: 'PENDIENTE',
    paraLlevar: 'all',
    tiempoPreparacion: 15,
    areasProduccionSelect: [],
    silencio: false,
    mostrarAnulados: false
};

@Injectable()
@State<CocinaRestaurantStateModel>({
    name: 'restaurant_cocina',
    defaults: {
        filtros: COCINA_FILTROS_DEFAULT
    }
})
export class CocinaRestauranteState {

    @Selector()
    static filtros(state: CocinaRestaurantStateModel): CocinaFiltros {
        // Los filtros guardados por versiones anteriores pueden no traer las claves nuevas.
        return {...COCINA_FILTROS_DEFAULT, ...(state.filtros || {})};
    }

    @Action(SetFiltros)
    setFiltros({getState, setState}: StateContext<CocinaRestaurantStateModel>, {filtros}: SetFiltros) {
        setState({...getState(), filtros: {...getState().filtros, ...filtros}});
    }

}
